import type { ClickableT } from '@mentimeter/ragnar-ui/clickable';
import { Clickable as RagnarClickable } from '@mentimeter/ragnar-ui/clickable';
import { EnablePrefetchLink } from '../../utils/EnablePrefetchLink';

export const Clickable: React.FC<ClickableT> =
  EnablePrefetchLink<ClickableT>(RagnarClickable);
